
import { Suspense, ReactNode, useState, useEffect } from 'react';
import { Skeleton } from './ui/skeleton';

interface LazyLoadProps {
  children: ReactNode;
  delay?: number;
}

// Optimized lazy loading with minimal skeleton to prevent blank screens
const LazyLoad = ({ children, delay = 0 }: LazyLoadProps) => {
  const [showSkeleton, setShowSkeleton] = useState(false);
  
  useEffect(() => {
    // Only show skeleton after a brief delay to avoid flashing for quick loads
    const timer = setTimeout(() => {
      setShowSkeleton(true);
    }, delay);
    
    return () => clearTimeout(timer);
  }, [delay]);
  
  return (
    <Suspense 
      fallback={
        showSkeleton ? (
          <div className="w-full animate-pulse p-2">
            <Skeleton className="h-8 w-1/3 mb-2" />
            <Skeleton className="h-24 w-full" />
          </div>
        ) : (
          <div className="min-h-[100px] w-full" />
        )
      }
    >
      {children}
    </Suspense>
  );
};

export default LazyLoad;
